import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AuthLayout from "./AuthLayout";
const Login = LazyLoad(lazy(() => import("../pages/auth/Login")));
const Register = LazyLoad(lazy(() => import("../pages/auth/Register")));
const ForgotPassword = LazyLoad(
  lazy(() => import("../pages/auth/ForgotPassword"))
);
const VerifyOTP = LazyLoad(lazy(() => import("../pages/auth/VerifyOTP")));
const ResetPassword = LazyLoad(
  lazy(() => import("../pages/auth/ResetPassword"))
);
const Congratulations = LazyLoad(
  lazy(() => import("../pages/auth/Congratulations"))
);

const AuthRoutes = {
  path: "/",
  element: <AuthLayout />,
  children: [
    {
      path: "/",
      element: <Login />,
    },

    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },

    {
      path: "verify-OTP",
      element: <VerifyOTP />,
    },
    {
      path: "reset-password",
      element: <ResetPassword />,
    },
    {
      path: "congratulations",
      element: <Congratulations />,
    },
  ],
};

export default AuthRoutes;
